import _defineProperty from '@babel/runtime/helpers/defineProperty';
import macro from '../../macros.js';
import vtkLocator from './Locator.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function vtkAbstractPointLocator(publicAPI, model) {
  // Set our className
  model.classHierarchy.push('vtkAbstractPointLocator');
} // ----------------------------------------------------------------------------
// Object factory
// ----------------------------------------------------------------------------


function defaultValues(initialValues) {
  return _objectSpread({
    bounds: null,
    numberOfBuckets: 0
  }, initialValues);
} // ----------------------------------------------------------------------------


function extend(publicAPI, model) {
  var initialValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  vtkLocator.extend(publicAPI, model, defaultValues(initialValues)); // Make this a VTK object

  macro.obj(publicAPI, model);
  macro.get(publicAPI, model, ['numberOfBuckets']);
  macro.setGetArray(publicAPI, model, ['bounds'], 6); // Object specific methods

  vtkAbstractPointLocator(publicAPI, model);
} // ----------------------------------------------------------------------------

var vtkAbstractPointLocator$1 = {
  extend: extend
};

export { vtkAbstractPointLocator$1 as default, extend };
